// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3874": "5f0fd3825e11","5395": "b9049a98ba70","8272": "9f9b245e3e36",}[chunkId] + ".css"
}